module.exports = __webpack_public_path__ + "static/chisel-4eb15d1080f41eaf3dd1302502a68302.svg";